import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { LearnerService } from 'src/app/services/learner.service';
import { FileQueueObject, FileUploaderService } from 'src/app/services/file-uploader.service';
import { Observable } from 'rxjs';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import * as _ from 'lodash'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileDetailsComponent } from 'src/app/commons/file-details/file-details.component';
import { AssetService } from 'src/app/services/asset.service';
import { UtilityService } from 'src/app/services/utility.service'

@Component({
  selector: 'app-add-evidence-modal',
  templateUrl: './add-evidence-modal.component.html',
  styleUrls: ['./add-evidence-modal.component.scss']
})
export class AddEvidenceModalComponent implements OnInit {

  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();

  eviTitle;
  eviDescription
  enableSave: boolean;
  evidenceFiles;
  files: any;
  queue: Observable<FileQueueObject[]>;
  loading: boolean;
  deletedFiles: any = [];
  evidenceForm: FormGroup

  displayErr: boolean = false;

  constructor(public _portfolioService: PortfolioService, public _utilityService: UtilityService, public _snackbar: MatSnackBar, public _learnerService: LearnerService,
    public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public uploader: FileUploaderService,
    public dialog: MatDialog, public _snackBar: MatSnackBar, private formBuilder: FormBuilder, public _assetService: AssetService) { }

  ngOnInit() {
    if (this.data && this.data.isEdit) {
      this.files = this.data.evi.files
      this.createForm(this.data.evi)
    } else
      this.createForm()
    // if (this.data && this.data.isEdit) {
    //   this.files = this.data.evi.files
    //   this.eviTitle = this.data.evi.title
    //   this.eviDescription = this.data.evi.description
    //   console.log("is edit true hence need to call file tile", this.files, this.eviTitle);
    // }
    this.queue = this.uploader.queue;
    this.queue.subscribe(res => {
      console.log("%c SOMETHING CHANGED IN QUEUE=====>>>>>", "color:red", res);
      if (res.length == 0) {
        this.enableSave = true
      }
      else {
        this.enableSave = false
      }
    })
  }

  createForm(data?) {
    console.log("data in createForm()", data);
    this.evidenceForm = this.formBuilder.group({
      eviTitle: new FormControl((data && data.title) ? data.title : '', Validators.required),
      eviDescription: new FormControl((data && data.description) ? data.description : ''),
      eviFeedback: new FormControl((data && data.feedback) ? data.feedback : '')
    }) 
  }

  save() {
    this.loading = true
    console.log("this.evidenceForm.value", this.evidenceForm.value);
    console.log("learnerId", this.data.learnerId);

    // console.log("FINAL OBJECT", data);
    if (this.evidenceForm.value.eviTitle) {
      if (this.data && this.data.isEdit) {
        let data = {
          learnerId: this.data.learnerId,
          evidenceId: this.data.evi._id,
          title: this.evidenceForm.value.eviTitle,
          description: this.evidenceForm.value.eviDescription,
          feedback:this.evidenceForm.value.eviFeedback,
          deletedFiles: this.deletedFiles,
          jobId: this.data.jobId
        }
        if (this.evidenceFiles) {
          data['files'] = this.evidenceFiles
        }
        console.log('data to submit', data)

        this._learnerService.editEvidence(data).subscribe(res => {
          // this.openSnackBar("Evidence Edit successfully!", "Ok");
          this._utilityService.openSnackBar("Evidence Edit successfully!", "Ok")
          this.loading = false
          console.log("RES AFTER EDIT EVIDENCE", res)
          // this.dialogRef.close(res)
          this._assetService.closeDisplayFile(true)
          this.close({
            action: 'edit',
            result: 'success',
            data: res
          });
        }, (err) => {
          console.log("Hello Here Is Somthing Went Wrong..", err)
          // alert('Something went wrong!',)
        })
      }
      else {
        let data = {
          learnerId: this.data.learnerId,
          title: this.evidenceForm.value.eviTitle,
          description: this.evidenceForm.value.eviDescription,
          files: this.evidenceFiles,
          jobId: this.data.jobId
        }
        /* ===== This is my section ======*/
        this.loading = true
        this._learnerService.addEvidence(data).subscribe(res => {
          this._utilityService.openSnackBar("Evidence created successfully!", "Ok")
          // this.openSnackBar("Evidence created successfully!", "Ok");
          console.log("res in evidence", res)
          this._assetService.closeDisplayFile(true)
          this.dialogRef.close(res)
          this.loading = false
        })
      }
    }
    else {
      console.log('IN ELSE');
      this.loading = false
      this.displayErr = true

    }

  }

  delete() {
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, 'Evidence').afterClosed().subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        console.log('DELETE')
        this.loading = true;
        console.log("check job id add evidence model=====>", this.data.jobId)
        this._learnerService.deleteEvidence(this.data.evi._id, this.data.learnerId, this.data.jobId).subscribe(evidence => {
          this._utilityService.openSnackBar("Evidence deleted successfully!", "Ok")
          // this.openSnackBar("Evidence deleted successfully!", "Ok");
          console.log("EVIDENCE RESPONSE", evidence)
          this.loading = false;
          this.close({
            action: 'delete',
            result: 'success',
            data: evidence
          });
        }, err => {
          this.loading = false;
          this.close({
            action: 'delete',
            result: 'err',
            data: err
          });
        });
      }
    })
  }

  deletedFile(event) {
    this._utilityService.openSnackBar("File deleted successfully!", "Ok")
    // this.openSnackBar("File deleted successfully!", "Ok");
    console.log("File Deleted Event : ", event);
    this.deletedFiles.push(event)
    console.log('this.deletedFiles', this.deletedFiles)
    let index = _.findIndex(this.files, function (o) { return o._id == event })
    if (index > -1) {
      this.files[index]['isDeleted'] = true;
      this.files.splice(index, 1)
    }
    // this.files.splice(this.files.findIndex(function (i) {
    //   return i._id === event._id;
    // }), 1);
  }

  eviFiles(event) {
    console.log("event", event);
    this.evidenceFiles = event.files;
    // this.files.push(event.files)
    this.enableSave = true
  }

  close(result) {
    this.dialogRef.close(result)
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  fileDetails(event) {
    console.log("event ====", event);
    // this.previousIndex = event.index
    // this.openFilesSideNav.emit({ event })
    this._learnerService.displayFile(event)
    // this.openDialog(FileDetailsComponent, event.file).subscribe(file=>{
    //   console.log("Test")
    // })
  
  }

}
